import React from 'react';
import EnterpriseLanding from '../pages/EnterpriseLanding';
import TagcLanding from '../pages/TagcLanding';
import HaleLandingPage from '../pages/HaleLandingPage';

/* ====================================================================
 * BrandRoot
 *
 * Single source of truth for what renders at "/".
 *
 *   REACT_APP_BRAND="tagc"      → TagcLanding (The Agyekum Group)
 *   REACT_APP_BRAND="hale"      → HaleLandingPage (The Hale League)
 *   REACT_APP_BRAND="toxintel"  → EnterpriseLanding (ToxIntel)
 *   (unset / anything else)     → EnterpriseLanding (safe default)
 *
 * The Hale deployment (REACT_APP_BRAND=hale, hale.toxintel.tagc.us)
 * serves the redesigned Hale League landing at "/" — the same page as
 * the /hale route, so the domain root and /hale stay consistent.
 * The ToxIntel page is never removed (stays at /toxintel and is "/" for
 * the toxintel-branded deployment).
 * ==================================================================== */

export default function BrandRoot() {
  const brand = (process.env.REACT_APP_BRAND || 'toxintel').toLowerCase();
  if (brand === 'tagc') {
    return <TagcLanding />;
  }
  if (brand === 'hale') {
    return <HaleLandingPage />;
  }
  return <EnterpriseLanding />;
}
